import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Row, Col, Container} from 'react-bootstrap';
import '../../../assets/Styles/DispatchCSS/TripActions/AdminFunctions/AgentInstructions.css';
import APICom from "../../../utils/helpers/APICom";
import { useRef } from "react";
import { useSelector } from "react-redux";

const AgentInstructions = (props) => {

    const AddNotesRef = useRef();
    const { loginData } = useSelector((store) => store.login);
    const [ showAgentInstructionAlert, setAgentInstructionAlert] = useState(false);
    const [ aiAlertObj, setAIAlertObj] = useState({alertTitle: '', alertMsg:''});
    const [showAgenInstructionDialog, setAgentInstructionDialog] = useState(false);
    const [agentInstrunctionObj, setAgentInstructionObj] = useState({name:'', homePhone:'', cellPhone:'', medicalID: '', ambCount: '0', wcCount:'0', active: 'false',
    ambPCA: '0', pcaWC: '0', emgName: '', emgPh: '', clientID : -1, iRefID: '0', remarks:'', address: '', agentPrevNotes:''});

    useEffect(() => {
        if(props.GridRowData === null || props.GridRowData.length <= 0)
        {
            setAIAlertObj({...agentInstrunctionObj, alertTitle: 'No trip selected', alertMsg:'No request selected.'});
            setAgentInstructionAlert(true);
        }
        else
        {
            GetAgentNotesByRefID();
            GetClientInformation();
        }
        
    }, []);

    const GetAgentNotesByRefID = async () => {
        const gData = props.GridRowData[0];
        var Param = {
            "iRefID": gData.ConfirmationNo,
            "iATSPID": gData.iSRATSPID,
            "iClientID": gData.ClientID,
            "vNotes": "",
            "iAppID": "26",
            "iUserID" : -1,
            "vUserName": "",
            "isAppliedToProfile":true
        }
        let response = await APICom.fetchData("", "TripActions/FetchAgentNotesByTripID", "post", { "Content-Type": "application/json" }, Param, null);
        let result = response.data;
        if(typeof(result.agentNotes) === 'object')
        {
            setAgentInstructionObj((prevState) => ({...prevState, agentPrevNotes: result.agentNotes.TripAgentInstructions }))
            if(showAgenInstructionDialog === false)
            {
                setAgentInstructionDialog(true);
            }
        }
    }

    const GetClientInformation = async () => {
        const gData = props.GridRowData[0];
        var Param = {
            "iRefID": gData.ConfirmationNo,
            "iATSPID": gData.iSRATSPID,
            "iClientID": gData.ClientID,
            "vNotes": "",
            "iAppID": "26",
            "iUserID" : -1,
            "vUserName": "",
            "isAppliedToProfile":true

        }
        let response = await APICom.fetchData("", "TripActions/GetClientInformation", "post", { "Content-Type": "application/json" }, Param, null);
        let result = response.data;
        if(typeof(result.ClientInfo) === 'object')
        {
            let clientName = result.ClientInfo.vFirstName + ' ' + result.ClientInfo.vLastName;
            let clientStatus = result.ClientInfo.bIsActive;
            let clientAddress = result.ClientInfo.vAddress1 + ' ' + result.ClientInfo.vState + ' ' + result.ClientInfo.vZip;
            let clientHome = result.ClientInfo.vHomePhone;
            let clientCell = result.ClientInfo.vCellPhone;
            let medicalID = result.ClientInfo.vMedicalId;
            let clientAMBCount = result.ClientInfo.iAmbulatoryCount;
            let clientWCCount = result.ClientInfo.iWheelChairCount;
            let clientPCAAMB = result.ClientInfo.iAmbulatoryPCACount;
            let clientPCAWC = result.ClientInfo.iWheelChairPCACount;
            let clientEmgName = (result.ClientInfo.vEmergency_firstname) ? result.ClientInfo.vEmergency_firstname : "" + ' ' + (result.ClientInfo.vEmergency_lastname) ? result.ClientInfo.vEmergency_lastname : "";
            let clientEmgContact = (result.ClientInfo.vEmergency_PhoneNo) ? result.ClientInfo.vEmergency_PhoneNo:"";
            let clientAgentNotes = (result.ClientInfo.vNotes) ? result.ClientInfo.vNotes:"";
            let clientRemarks = (result.ClientInfo.vRemarks) ? result.ClientInfo.vRemarks:"";

            
            setAgentInstructionObj((prevState) => ({...prevState, 
                name:(clientName) ? clientName : "",
                homePhone:(clientHome) ? clientHome : "",
                cellPhone:(clientCell) ? clientCell : "",
                medicalID: (medicalID) ? medicalID: "", 
                ambCount: (clientAMBCount) ? clientAMBCount : 0, 
                wcCount:(clientWCCount) ? clientWCCount : 0, 
                active: (clientStatus) ? clientStatus : "",
                ambPCA: (clientPCAAMB) ? clientPCAAMB : 0, 
                pcaWC: (clientPCAWC) ? clientPCAWC : 0, 
                emgName: (clientEmgName) ? clientEmgName : "", 
                emgPh: (clientEmgContact) ? clientEmgContact : "", 
                clientID : gData.ClientID, 
                iRefID: gData.ConfirmationNo, 
                remarks:clientRemarks, 
                address: (clientAddress) ? clientAddress : ""
                 }))
            if(showAgenInstructionDialog === false)
            {
                setAgentInstructionDialog(true);
            }
        }
    }

    const handleSaveAgentInstructionClose = async() => {
        const gData = props.GridRowData[0];
        var Param = {
            "iRefID": gData.ConfirmationNo,
            "iATSPID": gData.iSRATSPID,
            "iClientID": gData.ClientID,
            "vNotes": AddNotesRef.current.value,
            "iAppID": "26",
            "iUserID" : loginData.iUserID,
            "vUserName": loginData.vDisplayName,
            "isAppliedToProfile" : false
        }
        let response = await APICom.fetchData("", "TripActions/SaveNotesForTrip", "post", { "Content-Type": "application/json" }, Param, null);
        let result = response.data;
        if(result === "Success")
        {
            setAIAlertObj({...agentInstrunctionObj, alertTitle: 'Save', alertMsg:'Agent instruction notes saved successfully.'});
            setAgentInstructionAlert(true);
        }
        else
        {
            setAIAlertObj({...agentInstrunctionObj, alertTitle: 'Fail', alertMsg:'Agent instruction notes not saved.'});
            setAgentInstructionAlert(true);
        }
    }

    const handleAgentInstructionClose = ()=> {
        setAgentInstructionDialog(false);
        UnMountAgentInstructionComponent();
    }

    const handleAgentInstructionAlertClose = () => {
        setAIAlertObj(false);
        UnMountAgentInstructionComponent();
    }

    const UnMountAgentInstructionComponent = () => {
        if(props.agentInstructionComponentLoaded)
        {
            props.setAgentInstructionComponentLoad(false);
        }
    }

    return(
        <>
           <Modal centered show={showAgenInstructionDialog} onHide={handleAgentInstructionClose} animation={false} size="lg">
                <Modal.Header className="agentinstruction_dialog_header_bgcolor" closeButton>
                    <Modal.Title className="agentinstruction_dialog_title_color user-select-none">Dispatcher Notes</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <Col xs={12} md={4} className="p-0 user-select-none">
                                <Form.Label><b>Name:</b> {agentInstrunctionObj.name}</Form.Label>
                            </Col>
                            <Col xs={12} md={4} className="p-0 user-select-none">
                                <Form.Label><b>Home Ph:</b> {agentInstrunctionObj.homePhone}</Form.Label>
                            </Col>
                            <Col xs={6} md={4} className="p-0 user-select-none">
                                <Form.Label><b>Cell Ph:</b> {agentInstrunctionObj.cellPhone}</Form.Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={4} className="p-0 user-select-none">
                                <Form.Label><b>Medical ID:</b> {agentInstrunctionObj.medicalID}</Form.Label>
                            </Col>
                            <Col xs={12} md={4} className="p-0 user-select-none">
                                <Form.Label><b>AMB Count:</b> {agentInstrunctionObj.ambCount}</Form.Label>
                            </Col>
                            <Col xs={6} md={4} className="p-0 user-select-none">
                                <Form.Label><b>WC Count:</b> {agentInstrunctionObj.wcCount}</Form.Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={4} className="p-0 user-select-none">
                                <Form.Label><b>Active:</b> {agentInstrunctionObj.active}</Form.Label>
                            </Col>
                            <Col xs={12} md={4} className="p-0 user-select-none">
                                <Form.Label><b>AMB PCA:</b> {agentInstrunctionObj.ambPCA}</Form.Label>
                            </Col>
                            <Col xs={6} md={4} className="p-0 user-select-none">
                                <Form.Label><b>AMB WC:</b> {agentInstrunctionObj.pcaWC}</Form.Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={4} className="p-0 user-select-none">
                                <Form.Label><b>Emg. Name:</b> {agentInstrunctionObj.emgName}</Form.Label>
                            </Col>
                            <Col xs={12} md={4} className="p-0 user-select-none">
                                <Form.Label><b>Emg. Ph:</b> {agentInstrunctionObj.emgPh}</Form.Label>
                            </Col>
                            <Col xs={6} md={4} className="p-0 user-select-none">
                                <Form.Label><b>Client ID:</b> {agentInstrunctionObj.clientID}</Form.Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={4} className="p-0 user-select-none">
                                <Form.Label><b>Conf#:</b> {agentInstrunctionObj.iRefID}</Form.Label>
                            </Col>
                            <Col xs={12} md={4} className="p-0 user-select-none">
                                <Form.Label><b>Remarks:</b> {agentInstrunctionObj.remarks}</Form.Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} className="p-0 user-select-none">
                                <Form.Label><b>Address:</b> {agentInstrunctionObj.address}</Form.Label>
                            </Col>
                        </Row>
                    </Container>
                    <Form>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                        <Form.Label className="user-select-none"><b>Agent Notes:</b></Form.Label>
                        <Form.Control className="agentinstruction_agent_Notes" as="textarea" rows={2} readOnly={true} value={agentInstrunctionObj.agentPrevNotes} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea2">
                        <Form.Label className="user-select-none"><b>Add Notes: </b></Form.Label>
                        <Form.Control as="textarea" rows={2} ref={AddNotesRef} />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleAgentInstructionClose}>
                    Close
                </Button>
                <Button className="agentinstruction_btn_ok" onClick={handleSaveAgentInstructionClose}>
                    Save Changes
                </Button>
                </Modal.Footer>
            </Modal>
            { showAgentInstructionAlert && <Modal centered show={showAgentInstructionAlert} onHide={handleAgentInstructionAlertClose} animation={false} >
                                  <Modal.Header className='activate_dialog_header_bgcolor' style={{height: "50px"}} closeButton>
                                    <Modal.Title className='activate_dialog_title_color'>{aiAlertObj.alertTitle}</Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body><b>{aiAlertObj.alertMsg}</b></Modal.Body>
                                  <Modal.Footer>
                                    <Button variant="secondary" onClick={handleAgentInstructionAlertClose}>
                                      Close
                                    </Button>
                                  </Modal.Footer>
                                </Modal>}
        </>
    );
}

export default AgentInstructions;